import React from "react";

/** Shared card-style block for Diagnosis & Nutrition subsections (view + edit). */
export const DiagnosisNutritionSubsection = ({
  title,
  children,
  empty = false,
  emptyText = "None added",
  className = "",
}) => (
  <section
    className={`rounded-lg border border-indigo-100/90 bg-white overflow-hidden shadow-sm ${className}`}
    aria-labelledby={`dn-sub-${title.replace(/\s+/g, "-").toLowerCase()}`}
  >
    <header className="px-3 py-2 bg-gradient-to-r from-indigo-50 to-violet-50/80 border-b border-indigo-100">
      <h4
        id={`dn-sub-${title.replace(/\s+/g, "-").toLowerCase()}`}
        className="text-[11px] font-bold uppercase tracking-[0.08em] text-indigo-800"
      >
        {title}
      </h4>
    </header>
    <div className="px-3 py-3 sm:px-4 sm:py-3.5">
      {empty ? (
        <p className="text-sm text-slate-500 italic">{emptyText}</p>
      ) : (
        children
      )}
    </div>
  </section>
);

/** Stack wrapper for the four subsections inside the main section card. */
export const DiagnosisNutritionSubsectionStack = ({ children, className = "" }) => (
  <div className={`flex flex-col gap-3 p-3 sm:p-4 ${className}`}>{children}</div>
);

/** Print-friendly subsection (no shadow, compact). */
export const PrintDiagnosisNutritionSubsection = ({
  title,
  children,
  empty = false,
  emptyText = "None added",
}) => (
  <div className="rounded border border-slate-200 overflow-hidden break-inside-avoid">
    <div className="px-2.5 py-1 bg-slate-100 border-b border-slate-200">
      <p className="text-[9px] font-bold uppercase tracking-wide text-slate-700">
        {title}
      </p>
    </div>
    <div className="px-2.5 py-2 bg-white">
      {empty ? (
        <p className="text-[12px] text-slate-500 italic">{emptyText}</p>
      ) : (
        children
      )}
    </div>
  </div>
);

export const PrintDiagnosisNutritionSubsectionStack = ({ children }) => (
  <div className="space-y-2.5">{children}</div>
);
